<button (click)="openSettingsModal()" *ngIf="canEditCompanySettings" class="btn btn-icon btn-light settingButton" type="button"></button>

